import React, { useState, useEffect } from 'react';
import { Button } from 'aha-components';
import { isMobile } from '@/biz/tool';
import BottomDrawer from './BottomDrawer';
import WebModal from './Modal';
import { useWebModalStore } from '@/hooks/useWebModalStore';
const ModalWithdrawThisCollaboration: React.FC<{}> = () => {
  const { showModalDealWithdrawn, setShowModalDealWithdrawn } =
    useWebModalStore();

  const ModalContent = () => {
    return (
      <div className={`w-full flex flex-col items-center gap-6`}>
        <div
          className={`relative w-full flex flex-col items-center gap-6 
        `}
        >
          <div
            className={`overflow-auto flex flex-col gap-6 items-center
          ${isMobile() ? 'pb-20 pt-0' : ''}`}
          >
            <div className="self-stretch justify-start text-[#60646c] text-sm font-normal font-['Inter'] leading-normal mt-2">
              You have withdrawn from this brand deal. Aha will continue to
              match you with the deals that best match your channel!
            </div>
          </div>
        </div>
        {/*  */}
        <div
          className={`bg-white w-full flex justify-end items-center gap-4 border-t border-solid border-[#e8e8ec] pt-4
            ${isMobile() ? 'justify-center fixed bottom-0 left-0 pb-4 px-4' : ''}
          `}
        >
          <Button
            onClick={() => {
              setShowModalDealWithdrawn(false);
              window.location.reload();
            }}
            type="primary"
            className={`
              ${isMobile() ? '!px-6 !w-full' : ''}
            `}
          >
            OK
          </Button>
        </div>
      </div>
    );
  };
  return (
    <>
      {isMobile() ? (
        <BottomDrawer
          title="Deal withdrawn"
          visible={showModalDealWithdrawn}
          handleClose={() => setShowModalDealWithdrawn(false)}
          isShowFooter={false}
          // isShowHeader={false}
          rootClassName="!z-[9999]"
        >
          <ModalContent />
        </BottomDrawer>
      ) : (
        <WebModal
          title="Deal withdrawn"
          width={642}
          visible={showModalDealWithdrawn}
          handleClose={() => setShowModalDealWithdrawn(false)}
          isShowFooter={false}
          // isShowHeader={false}
        >
          <ModalContent />
        </WebModal>
      )}
    </>
  );
};

export default ModalWithdrawThisCollaboration;
